import { useProvider } from '@adobe/react-spectrum';
export var useSpectrumThemeProvider = useProvider;
export default useSpectrumThemeProvider;
//# sourceMappingURL=useSpectrumThemeProvider.js.map